// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsxRuntime classic */
/* @jsx mdx */
import PostHeader from "@/components/PostHeader";
import Media from "@/components/Media";
import BlogGallery from "@/components/BlogGallery";
import Button from "@/components/Button";


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PostHeader title='A Website for a Energy Consulting Company' projectName='Cone' imageName='cone/preview-image.png' date='2020' order='5' stack='(VueJS, Wordpress API, HTML, CSS, Javascript)' mdxType="PostHeader" />
    <h3>{`Website`}</h3>
    <div class='blogGallery'>
    <p>First Version</p>
    <iframe src="https://www.youtube.com/embed/3IfNPl5xoog" title="Test - Mudança de background." frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen />
    <p>Vue Speed Test</p>
    <iframe src="https://www.youtube.com/embed/o1Tgede70LE" title="vue template test" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    <div class='buttonGroup'>
        <Button href='https://coneconsultoria.com.br/' target='_blank' mdxType="Button">Visit website</Button>
    </div>
    </div>
    <h3>{`Re-branding`}</h3>
    <div class="blogGallery">
    <Media src='/work/cone/idea-colors.png' mdxType="Media" />
    <Media src='/work/cone/logo-comparing.png' mdxType="Media" />
    <Media src='/work/cone/new-logo.png' mdxType="Media" />
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   